import {required} from "vuelidate/lib/validators";  
const OKurumSabit = {
    data() {
      return {  
          FormDataType:{  
            EButceKullaniciAdi:{FieldName:"EButceKullaniciAdi",Field:"input",FieldTitle:this.$t('OKurumSabit.AddEdit.EButceKullaniciAdi')}, 
            EButceSifre:{FieldName:"EButceSifre",Field:"input",FieldTitle:this.$t('OKurumSabit.AddEdit.EButceSifre')}, 
          }    
      }
    },
    validations:{ 
      FormData: {
        EButceKullaniciAdi: { required }, 
        EButceSifre: { required }   
    }  
  },
}
export default OKurumSabit